<template>
  <div class="order-purchased-box max-width-box">
    <div class="myinfo-com-pur-content" v-if="!orderInformationVisible">
      <div class="list-head">
        <div class="flex_8">Order-information</div>
        <div class="flex_4">Price-Info</div>
        <div class="flex_3">Order-Status</div>
        <div class="flex_3">Progress</div>
        <div class="flex_6">Time-Info</div>
        <div class="flex_3">Operation</div>
      </div>
      <div
        class="list-content"
        v-for="(item, index) in purchasedOrderList"
        :key="index"
      >
        <div class="flex_8 info-box">
          <img class="info-img" :src="item.covey_course.courseImg[0]" />
          <div style="width: 8px; height: 100%; display: inline-block"></div>
          <div class="info-detail">
            <div class="detail-title" :title="item.covey_course.courseName">
              {{ item.covey_course.courseName }}
            </div>
            <!-- <div class="detail-content" :title="item.covey_user.realname">Tutor: {{item.covey_user.realname}}</div> -->
            <div class="id_time">
              <div class="detail-content">
                Course ID: {{ item.covey_course.courseNo }}
              </div>
              <div class="detail-content">Order ID: {{ item.id }}</div>
            </div>
          </div>
        </div>

        <div class="flex_4 operation">
          <div class="price-info-detail">
            <div
              class="detail-content"
              :title="'C$ ' + (item.pay_price / 100).toFixed(2)"
            >
              <div>Price:</div>
              <span>C$ {{ (item.pay_price / 100).toFixed(2) }}</span>
            </div>
            <!-- <div class="detail-content" :title="'$ '+(item.price/100).toFixed(2)">
                            <div>Regular Price: </div>
                            <span>$ {{(item.price/100).toFixed(2)}}</span>
                        </div> -->
            <div
              class="detail-content"
              :title="'C$ ' + (item.pay_money / 100).toFixed(2)"
            >
              <div>Order Fee:</div>
              <span>C$ {{ (item.pay_money / 100).toFixed(2) }}</span>
            </div>
            <div
              v-if="item.refund_status !== 0"
              class="detail-content"
              :title="'C$ ' + item.return_money"
            >
              <div>Refund:</div>
              <span>{{ "C$ " + (item.return_money / 100).toFixed(2) }}</span>
            </div>
          </div>
        </div>

        <div class="flex_3">
          <div>
            <i
              style="margin-right: 8px"
              :class="orderStatusMap[item.order_status].icon"
              :style="{ color: orderStatusMap[item.order_status].color }"
            ></i>
            <span>{{ orderStatusMap[item.order_status].name }}</span>
          </div>
          <div v-if="item.refund_status !== 0">
            <i
              style="margin-right: 8px"
              :class="refund_status[item.refund_status].icon"
              :style="{ color: refund_status[item.refund_status].color }"
            ></i>
            <span>{{ refund_status[item.refund_status].name }}(refund)</span>
          </div>
        </div>

        <div class="flex_3">
          <el-progress
            style="width: 90%"
            color="#f3ac50"
            :stroke-width="26"
            :format="(p) => orderProgressFomat(p, item)"
            :text-inside="true"
            :percentage="
              parseFloat(
                (
                  ((item.used_amounts + item.cancel_amounts) * 100) /
                  item.amounts
                ).toFixed(2)
              )
            "
          ></el-progress>
          <!-- 1.订单数量 amounts
                    2.使用数量 used_amounts
                    3.取消数量 cancel_amounts
                    4.进度条 值为 (使用数量+取消数量)/订单数量 -->
        </div>

        <div class="flex_6">
          <div class="price-info-detail">
            <div
              class="detail-content"
              :title="format(item.create_time, 'MM/DD/YYYY HH:mm:ss')"
            >
              <div>Create time:</div>
              <span class="ellipsis1">{{
                format(item.create_time, "MM/DD/YYYY HH:mm:ss")
              }}</span>
            </div>
            <div
              class="detail-content"
              :title="
                item.pay_time
                  ? format(item.pay_time, 'MM/DD/YYYY HH:mm:ss')
                  : ''
              "
            >
              <div>Pay time:</div>
              <span class="ellipsis1">{{
                item.pay_time
                  ? format(item.pay_time, "MM/DD/YYYY HH:mm:ss")
                  : ""
              }}</span>
            </div>
          </div>
        </div>
        <div class="flex_3 operation_events">
          <div><span @click="checkOrder(item)">View order</span></div>
        </div>
      </div>
      <div v-if="purchasedOrderList.length < 5">
        <div
          class="list-content"
          v-for="index in 5 - purchasedOrderList.length"
          :key="index"
        ></div>
      </div>
    </div>
    <KtPag
      v-if="!orderInformationVisible"
      style="text-align: right"
      :pageCount="orderlistForm.count"
      :currentPage="orderlistForm.page"
      :limit="orderlistForm.limit"
      @onChange="onPurchasedListPageChange"
    ></KtPag>

    <div class="order-information" v-if="orderInformationVisible">
      <div class="item-title" style="margin-top: 0">Order information</div>
      <div class="item-content">
        <div class="item-content-left">
          <img :src="orderDetail.covey_course.courseImg[0]" />
          <div class="order-info">
            <div>{{ orderDetail.covey_course.courseName }}</div>
            <div>Tutor: {{ orderDetail.coveyTeacherUser.realname }}</div>
            <div>Student: {{ orderDetail.coveyStudentUser.realname }}</div>
            <div>Course ID: {{ orderDetail.covey_course.courseNo }}</div>
            <div>Order ID: {{ orderDetail.id }}</div>
            <div>
              {{
                format(orderDetail.create_time, "ddd, MMM. Do, YYYY hh:mm A")
              }}
            </div>
          </div>
        </div>
        <div class="item-content-right">
          <div>C${{ (orderDetail.pay_money / 100).toFixed(2) }}</div>
          <div>Order Amounts: {{ orderDetail.amounts }}</div>
          <div>
            Pay Price: C$ {{ (orderDetail.price / 100).toFixed(2) }} / 1 lesson
          </div>
        </div>
      </div>
      <div class="item-title">
        <span>
          Course List
          <i
            style="font-size: 14px"
            class="el-icon-refresh goback"
            @click="getChildOrderList"
          ></i>
        </span>

        <a href="javascript:void(0)" @click="goBack">
          <el-button type="text" class="goback" icon="el-icon-back"
            >Back</el-button
          >
        </a>
      </div>
      <div class="order-course-list">
        <div class="list-head">
          <div class="flex_2">ClassID</div>
          <div class="flex_3">Time</div>
          <div class="flex_3">Room-Info</div>
          <div class="flex_3">Class-status</div>
          <div class="flex_3">Comment-status</div>
          <div class="flex_3">Operation</div>
        </div>
        <div
          class="list-content"
          v-for="(item, index) of childOrderList"
          :key="index"
        >
          <div class="flex_2">{{ item.id }}</div>
          <div
            class="flex_3"
            :title="
              format(item.apdate, 'ddd, MMM. Do, YYYY') +
              ' ' +
              item.starttime +
              '-' +
              item.endtime
            "
          >
            {{
              format(item.apdate, "ddd, MMM. Do, YYYY") +
              " " +
              item.starttime +
              "-" +
              item.endtime
            }}
          </div>

          <div class="flex_3">
            <div>
              site:
              <a
                class="room_site"
                v-if="item.roomsite"
                :href="item.roomsite"
                target="_blank"
                >Go to the site</a
              >
            </div>
            <div>code: {{ item.roomcode }}</div>
          </div>

          <div class="flex_3">
            <span :style="{ color: childOrderStatusMap[item.status].color }">
              <i
                style="margin-right: 8px"
                :class="childOrderStatusMap[item.status].icon"
              ></i>
              <span>{{ childOrderStatusMap[item.status].name }}</span>
            </span>
            <div
              v-if="
                item.complainstatus !== 0 && [1, 3, 4, 5].includes(item.status)
              "
            >
              {{ complainstatusMap[item.complainstatus] }}
            </div>
            <!-- <el-tooltip v-if="[1,3,4].includes(parseInt(item.status)) && item.complainstatus === 0" content="对此订单有异议，点击进行申述" placement="top" effect="light">
                            <div slot="content">对此订单有异议，<a href="javascript:void(0)" @click="gotoLessonappeal(item)">点击</a>进行申述</div>
                            <i class="el-icon-question"></i>
                        </el-tooltip> -->
          </div>

          <div class="flex_3">
            <div :style="{ color: commentstatusMap[item.commentstatus].color }">
              <i
                style="margin-right: 8px"
                :class="commentstatusMap[item.commentstatus].icon"
              ></i>
              <span>{{ commentstatusMap[item.commentstatus].name }}</span>
            </div>
          </div>

          <div class="flex_3 operation_events">
            <span
              v-if="item.status === 5 && item.commentstatus === 1"
              @click="openReviewdialog(item)"
              >Check Reviews</span
            >
            <div v-if="item.changeapply === 2">
              <el-tooltip effect="light" content="Rescheduled" placement="top">
                <i class="el-icon-warning"></i>
              </el-tooltip>
            </div>
            <div v-if="item.changeapply === 3">
              <el-tooltip
                effect="light"
                content="Rescheduling failed"
                placement="top"
              >
                <i class="el-icon-warning"></i>
              </el-tooltip>
            </div>
          </div>
        </div>

        <div v-if="childOrderList.length < 5">
          <div
            class="list-content"
            v-for="index in 5 - childOrderList.length"
            :key="index"
          ></div>
        </div>
      </div>
    </div>
    <KtPag
      v-if="orderInformationVisible"
      style="text-align: right"
      :pageCount="childOrderForm.count"
      :currentPage="childOrderForm.page"
      :limit="childOrderForm.limit"
      @onChange="onChildOrderSizeChange"
    ></KtPag>

    <el-dialog
      custom-class="evaluate-dialog"
      :visible.sync="evaluateDialog"
      :append-to-body="true"
      title="What do you think of"
    >
      <div class="tutor-name">French</div>
      <div class="tutor-star">
        <el-rate
          v-model="commentForm.rate"
          show-score
          score-template="{value}"
        ></el-rate>
      </div>
      <div class="star-info">Five-star praise! Great course, thumbs up!</div>
      <el-input
        type="textarea"
        style="margin-top: 32px"
        v-model="commentForm.content"
        :rows="5"
        placeholder="How is the course, tell me how you feel"
      ></el-input>
      <div class="box-foot">
        <div class="my-button cancel" @click="evaluateDialog = false">
          CANCEL
        </div>
        <div class="my-button" @click="handleSubmitEvaluate">SURE</div>
      </div>
    </el-dialog>

    <el-dialog
      v-if="commentInfo.covey_user"
      custom-class="student-reviews-dialog"
      :visible.sync="reviewDialog"
      append-to-body
      title="Course evaluation"
    >
      <div class="comment-card">
        <div class="comment-people">
          <div style="display: flex; align-items: center">
            <div class="circle">
              {{ userInfo.realname ? userInfo.realname[0] : "" }}
            </div>
            <span>{{ userInfo.realname }} (Me)</span>
          </div>
          <div class="main-title-right">
            <img src="@/assets/icon/star.png" />
            <span>{{ commentInfo.covey_comment.rate }}</span>
          </div>
        </div>
        <div class="comment-content">
          {{ commentInfo.covey_comment.content }}
        </div>
        <div class="comment-time">
          {{ format(commentInfo.covey_comment.comment_time) }}
        </div>
      </div>

      <div class="reply-card" v-if="commentInfo.covey_comment.is_reply === 1">
        <div class="reply-content">
          <div>
            See the response {{ commentInfo.covey_user.realname }} :
            {{ commentInfo.covey_comment.replied_content }}
          </div>
          <div class="reply-time">
            {{ format(commentInfo.covey_comment.replied_time) }}
          </div>
        </div>
      </div>
      <div class="box-foot">
        <div class="my-button cancel" @click="reviewDialog = false">CANCEL</div>
        <div class="my-button" @click="reviewDialog = false">SURE</div>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="appealResDialog"
      title="Support case result"
      width="60%"
    >
      <el-form :model="appealRes" label-width="200px">
        <el-form-item label="Order number:">
          <div>{{ appealRes.calendarId }}</div>
        </el-form-item>

        <el-form-item label="Description of issue:">
          <el-input
            type="textarea"
            v-model="appealRes.reason"
            :rows="5"
            disabled
          ></el-input>
        </el-form-item>

        <el-form-item label="Supporting materials:">
          <div style="display: flex">
            <div
              style="display: inline-block; margin-right: 12px"
              v-for="(item, index) in appealRes.proofImg"
              :key="index"
            >
              <img style="width: 180px; height: auto" :src="item" />
            </div>
          </div>
        </el-form-item>

        <el-form-item label="Tutor penalty amount:">
          <div>C$ {{ (appealRes.tutorpunishment / 100).toFixed(2) }}</div>
        </el-form-item>

        <el-form-item label="Send students coupons:">
          <div>C$ {{ (appealRes.sturefund / 100).toFixed(2) }}</div>
        </el-form-item>

        <el-form-item label="Status of case:">
          <div>{{ appealStatus[appealRes.status] }}</div>
        </el-form-item>
      </el-form>
      <div class="box-foot">
        <div class="my-button cancel" @click="appealResDialog = false">
          CANCEL
        </div>
        <div class="my-button" @click="appealResDialog = false">SURE</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ScheduleTable from "@/views/Pc/Component/ScheduleTable";
import { format } from "@/utils/comm";
import { mapState, mapGetters } from "vuex";
import KtPag from "@/views/Comm/KtPag";
export default {
  components: {
    ScheduleTable,
    KtPag,
  },
  computed: {
    ...mapState({
      xToken: (state) => state.app.token,
      userInfo: (state) => state.app.userInfo,
    }),
    ...mapGetters(["getUploadImg"]),
  },
  data() {
    return {
      queryStr: "",

      orderlistForm: {
        page: 1,
        limit: 10,
        count: 0,
      },
      purchasedOrderList: [],
      format: format,

      childOrderStatusMap: {
        //子订单
        "-1": {
          name: "Invalid lesson",
          icon: "el-icon-remove",
          color: "#7E8088",
        },
        0: {
          name: "Pending appointment",
          icon: "el-icon-loading",
          color: "#f48c06",
        },
        1: {
          name: "Appointment success",
          icon: "el-icon-success",
          color: "#3BB20A",
        },
        2: { name: "cancel", icon: "el-icon-error", color: "#f56c6c" },
        3: {
          name: "in progress of session",
          icon: "el-icon-error",
          color: "#f56c6c",
        },
        4: {
          name: "waiting to be confirmed",
          icon: "el-icon-error",
          color: "#f56c6c",
        },
        5: {
          name: "session completed",
          icon: "el-icon-success",
          color: "#3BB20A",
        },
      },
      orderStatusMap: {
        //父订单
        1: { name: "To be paid", icon: "el-icon-remove", color: "#7E8088" },
        2: { name: "paid", icon: "el-icon-success", color: "#3BB20A" },
        3: { name: "canceled", icon: "el-icon-error", color: "#f56c6c" },
        4: { name: "in progress", icon: "el-icon-loading", color: "#f48c06" },
        5: { name: "completed", icon: "el-icon-success", color: "#3BB20A" },
      },

      refund_status: {
        //退款状态
        0: { name: "Not applied", icon: "", color: "" },
        1: {
          name: "Refund in progress",
          icon: "el-icon-loading",
          color: "#f48c06",
        },
        2: {
          name: "Refund:Tutor agreed",
          icon: "el-icon-success",
          color: "#3BB20A",
        },
        3: {
          name: "Refund:Tutor rejected",
          icon: "el-icon-error",
          color: "#f56c6c",
        },
      },

      commentstatusMap: {
        //子订单的评论状态
        0: { name: "Not evaluated", icon: "", color: "" },
        1: { name: "Evaluated", icon: "el-icon-success", color: "#3BB20A" },
        2: { name: "Auto", icon: "el-icon-success", color: "#3BB20A" },
      },
      complainstatusMap: {
        0: "No supporting case filed.",
        1: "Supporting case in progress.",
        2: "Supporting case solved.",
        3: "Case failed.",
      },
      appealStatus: {
        1: "In progress",
        2: "Warning tutor",
        3: "Penalty tutor",
        4: "Refund",
      },

      orderInformationVisible: false,
      evaluateDialog: false,
      evaluateStar: 4.5,
      orderDetail: {},
      childOrderList: [], //子订单列表
      commentForm: {
        order_id: "",
        calendar_id: "",
        rate: 0,
        content: "",
      },
      commentInfo: {},
      reviewDialog: false,
      scheduleData: [],
      myClassTable: [], //点击change time 时修改的课程
      updateCourseTimeForm: {
        //
        targetTime: "", //申请的时间
        new_calendar_id: "",
        id: "",
        changeapply: 2, //2表示同意 3表示拒绝
        reject_reason: "", //拒绝时要填写原因
      },

      //申述
      lessonappealLoading: false,
      lessonappealForm: {
        //
        calendar_id: "",
        reason: "",
        proofImg: [],
      },

      appealResDialog: false, //申述结果
      appealRes: {},

      imgRules: "image/png , image/jpeg",
      childOrderForm: {
        page: 1,
        limit: 10,
        count: 0,
        type: "1",
      },
    };
  },
  watch: {
    "$route.query": function (newVal, oldVal) {
      this.initPage();
    },
  },
  created() {
    this.initPage();
  },
  methods: {
    orderProgressFomat(p, item) {
      return (
        "Total:" +
        item.amounts +
        " Used:" +
        item.used_amounts +
        " Canceled:" +
        item.cancel_amounts
      );
    },
    initPage() {
      if (this.$route.query && this.$route.query.orderId) {
        if (!this.orderDetail.covey_course) {
          this.$router.push({
            path: this.$route.path,
          });
          return;
        }
        this.orderInformationVisible = true;
        this.getChildOrderList();
      } else {
        this.orderInformationVisible = false;
        this.getPurchasedList();
      }
    },
    checkOrder(item) {
      this.orderDetail = item;
      this.$router.push({
        path: this.$route.path,
        query: {
          orderId: item.id,
        },
      });
    },
    onChildOrderSizeChange({ page, limit }) {
      this.childOrderForm.page = page;
      this.childOrderForm.limit = limit;
      this.getChildOrderList();
    },
    //课程订单详情页面下的子订单列表
    getChildOrderList() {
      let params = { ...this.childOrderForm };
      params["orderId"] = this.$route.query.orderId;
      delete params.count;

      this.childOrderList = [];
      this.$api.courseApi.getOrderLessons(params).then((res) => {
        if (res.status === "0") {
          this.childOrderList = res.data.rows;
          this.childOrderForm.count = res.data.count;
        }
      });
    },
    handleSubmitEvaluate() {
      let params = { ...this.commentForm };

      this.$api.courseApi.addComment(params).then((res) => {
        if (res.status === "0") {
          this.$message.success("Success!");
          this.getChildOrderList();
          this.evaluateDialog = false;
        } else {
          this.$message.error("Error:" + res.message);
        }
      });
    },
    onPurchasedListPageChange({ page, limit }) {
      this.orderlistForm.page = page;
      this.orderlistForm.limit = limit;
      this.getPurchasedList();
    },
    getPurchasedList() {
      let params = { ...this.orderlistForm };
      delete params.count;
      this.$api.orderApi.getClubOrders(params).then((res) => {
        if (res.status === "0") {
          this.orderlistForm.count = res.data.count;
          res.data.rows.forEach((item) => {
            item.covey_course.courseImg = JSON.parse(
              item.covey_course.courseImg || "[]"
            );
          });
          this.purchasedOrderList = res.data.rows;
        }
      });
    },

    //学生已经评价，查看评价
    openReviewdialog(item) {
      if (!item.covey_comment) {
        return;
      }
      this.commentInfo = item;
      this.reviewDialog = true;
    },
    goBack() {
      window.history.back();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/utils/vw.scss";
.order-purchased-box {
  width: 100%;
  height: 100%;
  // box-sizing: border-box;
  padding: 24px 32px;
  .flex_1,
  .flex_2,
  .flex_3,
  .flex_4,
  .flex_5,
  .flex_6,
  .flex_7,
  .flex_8,
  .flex_9,
  .flex_10 {
    padding: 0 6px;
    align-self: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .flex_1 {
    flex: 1;
  }
  .flex_2 {
    flex: 2;
  }
  .flex_3 {
    flex: 3;
  }
  .flex_4 {
    flex: 4;
  }
  .flex_5 {
    flex: 5;
  }
  .flex_6 {
    flex: 6;
  }
  .flex_7 {
    flex: 7;
  }
  .flex_8 {
    flex: 8;
  }
  .flex_9 {
    flex: 9;
  }
  .flex_10 {
    flex: 10;
  }
  .goback {
    color: #f48c06;
  }
  .operation {
    color: #f48c06;
    span {
      padding: 2px;
      color: #f48c06;
      cursor: pointer;
    }
  }
  .popover-operation {
    padding: 2px;
    color: #f48c06;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
  .operation_events {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    span {
      padding: 2px 4px;
      color: #f48c06;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .info-box {
    height: 100%;
  }
  .info-img {
    width: 35%;
    min-width: 108px;
    height: 76px;
    display: inline-block;
    border: 0.5px solid #dbd9d6;
    vertical-align: top;
  }
  .price-info-detail {
    width: 80%;
    display: inline-block;
    color: #201002;
    vertical-align: top;

    .detail-content {
      font-size: 14px;
      line-height: 16px;
      font-weight: 500;
      overflow: hidden;
      text-overflow: ellipsis;
      padding: 3px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      &:hover {
        background: #f0f0f0;
      }
    }
  }

  .info-detail {
    width: 58%;
    display: inline-block;
    color: #201002;
    vertical-align: top;
    .detail-title {
      font-size: 18px;
      font-weight: 500;
      line-height: 24px;
      overflow: hidden;
      text-overflow: ellipsis;
      // display: -webkit-box;
      // -webkit-line-clamp: 2;
      // -webkit-box-orient: vertical;
      // white-space: break-spaces;
    }
    .detail-content {
      font-size: 14px;
      line-height: 20px;
      font-weight: 500;
      overflow: hidden;
      text-overflow: ellipsis;

      display: flex;
      justify-content: space-between;
    }
    .detail-time {
      font-size: 14px;
      color: #b7b2ae;
      line-height: 20px;
      margin-top: 6px;
    }
    .id_time {
      color: #b7b2ae;
    }
  }

  .myinfo-com-pur-content {
    // margin-top: vw(32);
    box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    background: #ffffff;
    .list-head,
    .list-content {
      display: flex;
      padding: vw(12) vw(32);
      box-sizing: border-box;
    }
    .list-head {
      min-height: 72px;
      height: vw(72);
      font-size: 18px;
      color: #201002;
    }
    .list-content {
      min-height: 112px;
      // height: vw(138);
      border-top: 1px solid #dbd9d6;
      font-size: 14px;
      .operation {
        span {
          color: #f48c06;
          cursor: pointer;
        }
      }
    }
    .info {
      flex: 6;
      display: flex;
      // padding-right: vw(50);
      box-sizing: border-box;
      align-items: center;
      img {
        width: 136px !important;
        height: 100%;
        border-radius: 16px;
      }
    }
  }

  .order-information {
    .item-title {
      height: 30px;
      font-size: 24px;
      font-weight: 600;
      color: #201002;
      line-height: 30px;
      margin-top: 32px;
      display: flex;
      justify-content: space-between;
    }
    .item-content {
      margin-top: 32px;
      display: flex;
      justify-content: space-between;
      .item-content-left {
        display: flex;
        img {
          width: 200px;
          height: 146px;
          border-radius: 8px;
        }
        .order-info {
          margin-left: 24px;
          div:nth-child(1) {
            height: 24px;
            font-size: 18px;
            font-weight: 500;
            color: #201002;
            line-height: 24px;
          }
          div:nth-child(2) {
            font-size: 14px;
            margin-top: 16px;
          }
          div:nth-child(n + 3) {
            font-size: 14px;
            margin-top: 8px;
          }
        }
      }
      .item-content-right {
        text-align: right;
        div:nth-child(1) {
          height: 24px;
          font-size: 24px;
          font-weight: 600;
          color: #f48c06;
          line-height: 24px;
          margin-bottom: 76px;
        }
        div:nth-child(n + 2) {
          font-size: 14px;
        }
      }
    }

    .order-course-list {
      margin-top: vw(32);
      box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.04);
      border-radius: 8px;
      background: #ffffff;
      .list-head,
      .list-content {
        display: flex;
        padding: vw(24) vw(32);
        box-sizing: border-box;
      }
      .list-head {
        min-height: 73px;
        height: vw(73);
        font-size: 18px;
        color: #201002;
      }
      .list-content {
        min-height: 72px;
        height: vw(72);
        border-top: 1px solid #dbd9d6;
        font-size: 14px;
        .operation {
          span {
            color: #f48c06;
            cursor: pointer;
          }
        }
      }
    }
  }
}
.evaluate-dialog {
  border-radius: 8px;
  .el-dialog__header {
    padding: 32px 0;
    box-sizing: border-box;
    text-align: center;
    font-size: 24px;
    font-weight: 600;
    color: #201002;
    .el-dialog__title {
      font-size: 24px;
    }
  }
  .tutor-name {
    height: 30px;
    font-size: 18px;
    font-weight: 600;
    color: #201002;
    line-height: 30px;
    text-align: center;
  }
  .tutor-star {
    margin-top: 32px;
    text-align: center;
    i {
      color: rgba(244, 140, 6, 1);
      font-size: 24px;
    }
  }
  .star-info {
    text-align: center;
    height: 25px;
    font-size: 18px;
    font-weight: 500;
    color: #201002;
    line-height: 25px;
    margin-top: 16px;
  }
  .el-dialog__body {
    padding: 0 56px 46px;
    box-sizing: border-box;
    .box-foot {
      margin-top: 40px;
      display: flex;
      justify-content: center;
      font-size: 14px;
    }
  }
}
.student-reviews-dialog {
  border-radius: 8px;
  .el-dialog__header {
    padding: 32px 0;
    box-sizing: border-box;
    text-align: center;
    font-size: 24px;
    font-weight: 600;
    color: #201002;
    .el-dialog__title {
      font-size: 24px;
    }
  }
  .el-dialog__body {
    padding: 0 56px 46px;
    box-sizing: border-box;

    .comment-card {
      margin-top: 16px;
      padding: 16px;
      background: #fff;
      box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.04);
      border-radius: 8px;

      .comment-people {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .circle {
          width: 32px;
          height: 32px;
          background: #fecb3e;
          color: #fff;
          font-size: 18px;
          font-weight: 600;
          line-height: 32px;
          border-radius: 50%;
          margin-right: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
      .comment-content {
        height: auto;
        font-size: 14px;
        font-weight: 600;
        color: #201002;
        line-height: 30px;
        margin-top: 16px;
      }
      .comment-time {
        text-align: right;
        height: auto;
        font-size: 14px;
        font-weight: 600;
        color: #b7b2ae;
        line-height: 30px;
        margin-top: 16px;
      }
      .main-title-right {
        padding: 6px 16px;
        border-radius: 24px;
        background: rgba(252, 233, 209, 0.54);
        img {
          width: 12px;
          height: 12px;
          margin-right: 4px;
        }
      }
    }

    .reply-card {
      width: 100%;
      margin-top: 16px;
      display: flex;
      justify-content: flex-end;
      .reply-content {
        width: 520px;
        background: #e4e4e4;
        padding: 16px;
        box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.04);
        border-radius: 8px;
        line-height: 30px;
        color: #201002;
        font-weight: 600;
      }
      .reply-time {
        text-align: right;
        height: auto;
        font-size: 14px;
        font-weight: 600;
        color: #b7b2ae;
        line-height: 30px;
        margin-top: 16px;
      }
    }

    .box-foot {
      margin-top: 56px;
      display: flex;
      justify-content: center;
      font-size: 14px;
    }
  }
}

.box-foot {
  margin-top: 56px;
  display: flex;
  justify-content: center;
  font-size: 14px;

  .my-button {
    cursor: pointer;
    width: 120px;
    height: 48px;
    background: #f48c06;
    border-radius: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    span {
      font-size: 14px;
      color: #ffffff;
      line-height: 20px;
    }
  }

  .cancel {
    margin-right: 24px;
    background: #f2f2f2;
    color: #201002;
  }
  .el-textarea__inner {
    font-family: "PingFangSC-Semibold", "PingFang SC";
    border-radius: 8px;
  }
}
</style>